module.exports = __webpack_public_path__ + "static/media/50.d9bf7c41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/50.jpg
// module id = 740
// module chunks = 0